<template>
<div class="chapter">
<div class="inner_page">
<div id="cover">
<img alt="Bones in the Wilderness" class="cover-image" src="images/bellairs_boneswilderness_visual.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?382f7365